import messageLayout from '../../../layouts/message'

export default {
  path: 'message',
  component: messageLayout,
  children: [
    {
      path: '',
      redirect: 'center'
    },
    {
      path: 'center',
      component: () => import('./share'),
      meta: {
        activeMenu: 'message',
        auth: true
      }
    },
    {
      path: 'taskcenter',
      component: () => import('./task'),
      meta: {
        activeMenu: 'message',
        auth: true
      }
    },
    {
      path: 'applylist',
      component: () => import('./apply'),
      meta: {
        activeMenu: 'message',
        auth: true
      }
    },
    {
      path: 'hrchange',
      component: () => import('./hrChange'),
      meta: {
        activeMenu: 'message',
        auth: true
      }
    },
    {
      path: 'uploadcard',
      component: () => import('./upload'),
      meta: {
        activeMenu: 'message',
        auth: true
      }
    }
  ]
}
